import React from 'react'
import { useQueryParams } from '@fs/zion-router'
import { useFeatureFlag } from '@fs/zion-flags'
import { usePageWidth } from '@fs/zion-ui'
import { useOverlayContext } from '../../../shared/providers/overlayContextProvider/OverlayContext'
import IndexImage from '../../views/indexing/components/indexImage/IndexImage'
import SelectPerson from '../../views/indexing/components/selectPerson/SelectPerson'
import SelectPersonBottomSheet from '../../views/indexing/components/selectPerson/SelectPersonBottomSheet'
import SelectPersonV2 from '../../views/indexing/components/selectPersonV2/SelectPersonV2'
import FullText from '../../views/fullText/FullText'
import { useR2StateContext } from '../../providers/r2Provider/R2Context'
import SelectImagePrompt from './SelectImagePrompt'
import useInfoSheetOrientationCachedState from '../../../shared/hooks/useInfoSheetOrientationCachedState'

const SideSheetBody = ({ imageHasData, loading = false }) => {
  const { query } = useQueryParams()
  const { view, grid } = query || {}
  const r2State = useR2StateContext()
  const { inPanelStack } = useOverlayContext()
  const pageWidth = usePageWidth()
  const isMobile = pageWidth({ default: true, sm: false })
  const fullTextAttachFlowV2Flag = useFeatureFlag('rip_sharedImageViewer_fullTextAttachFlow_v2')
  const { isBottomSheet } = useInfoSheetOrientationCachedState()

  return (
    <>
      {fullTextAttachFlowV2Flag.isOn ? (
        <>
          {grid && view === 'index' ? (
            <SelectImagePrompt />
          ) : (
            <>
              <SelectPersonV2 loading={loading} />
              {(imageHasData || inPanelStack('addPersonPage1Generic')) && !r2State.resetState && <IndexImage />}
            </>
          )}
        </>
      ) : (
        <>
          {grid && view === 'index' && <SelectImagePrompt />}
          {!grid && view === 'index' && (
            <>
              {!isMobile && (
                <>
                  {isBottomSheet && <SelectPersonBottomSheet />}
                  {!isBottomSheet && <SelectPerson loading={loading} />}
                </>
              )}
              {isMobile && <SelectPerson loading={loading} />}
              {imageHasData && !r2State.resetState && <IndexImage />}
            </>
          )}
          {view === 'fullText' && <FullText />} {/* This only shows when V2 is off */}
        </>
      )}
    </>
  )
}

export default SideSheetBody
